// custom typefaces
// import "typeface-montserrat"
// import "typeface-merriweather"

import "@fontsource/plus-jakarta-sans/300.css";
import "@fontsource/plus-jakarta-sans/400.css";
import "@fontsource/plus-jakarta-sans/500.css";
import "@fontsource/plus-jakarta-sans/700.css";
import "@fontsource/plus-jakarta-sans/800.css";

// normalize CSS across browsers
import "./src/assets/css/normalize.css"

//slick styles
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

// custom CSS styles
import "./src/assets/css/style.css"
import "./src/assets/css/additional.css"
import "./src/assets/css/stars.css"
// import "./src/assets/css/grid.css"
import "./src/assets/css/bootstrap.min.css"

export const onRouteUpdate = () => {
  if (typeof window !== "undefined") {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 500)
  }
}
